import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-xl font-bold mb-4">Kempshot Sports Academy</h3>
            <p className="text-gray-400 mb-4">
              Developing the next generation of football talent through professional coaching and world-class facilities.
            </p>
            <div className="flex space-x-4">
              <a href="https://web.facebook.com/profile.php?id=61559738480857" className="text-gray-400 hover:text-white transition-colors">
                <FaFacebook className="h-6 w-6" />
              </a>
              {/* <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <FaTwitter className="h-6 w-6" />
              </a> */}
              {/* <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <FaInstagram className="h-6 w-6" />
              </a> */}
              {/* <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <FaYoutube className="h-6 w-6" />
              </a> */}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/auth/directory" className="text-gray-400 hover:text-white transition-colors">
                  Directory
                </Link>
              </li>
              <li>
                <Link to="/auth/programs" className="text-gray-400 hover:text-white transition-colors">
                  Programs
                </Link>
              </li>
              <li>
                <Link to="/auth/academy" className="text-gray-400 hover:text-white transition-colors">
                  Academy
                </Link>
              </li>
              <li>
                <Link to="/auth/schedule" className="text-gray-400 hover:text-white transition-colors">
                  Live Menu
                </Link>
              </li>
              <li>
                <Link to="/auth/about" className="text-gray-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-2 text-gray-400">
              <li>Fiifi Pratt Street, Nyanyano</li>
              <li>Central Region, Ghana, </li>
              <li>Phone: +233 054 337 0183</li>
              <li>Email: kemps@kempshot.com</li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Kempshot Sports Academy. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 